export var reduxKey = '@@firstTimeFlags';
export var localStorageKey = '@@firstTimeFlags';
export var FirstTimeFlag;
(function (FirstTimeFlag) {
    FirstTimeFlag["ProfileHeroAidNotClosed"] = "isProfileHeroAidNotClosed";
    FirstTimeFlag["ProfileEditAidNotClosed"] = "isProfileEditAidNotClosed";
    FirstTimeFlag["WelcomePopupNotClosed"] = "isWelcomePopupNotClosed";
    FirstTimeFlag["ArtBackgroundNotUsed"] = "isArtBackgroundNotUsed";
    FirstTimeFlag["IsJournalCoverNotUsed"] = "isJournalCoverNotUsed";
    FirstTimeFlag["IsPortfolioPopupNotClosed"] = "isPortfolioPopupNotClosed";
    FirstTimeFlag["IsChatGeneralTabNotUsed"] = "isChatGeneralTabNotUsed";
    FirstTimeFlag["IsNetworkbarGroupWatchNotUsed"] = "isNetworkbarGroupWatchNotUsed";
    FirstTimeFlag["IsDollarInputMessageNotShown"] = "isDollarInputMessageNotShown";
    FirstTimeFlag["IsMcGroupSwitcherNotUsed"] = "isMcGroupSwitcherNotUsed";
    FirstTimeFlag["IsDevpageAddToGroupNotShown"] = "isDevpageAddToGroupNotShown";
    FirstTimeFlag["IsArtShopBuyButtonMessageNotShown"] = "isArtShopBuyButtonMessageNotShown";
    FirstTimeFlag["IsArtShopInSiteHeaderNotSeen"] = "isArtShopInSiteHeaderNotSeen";
    FirstTimeFlag["IsDywUnreadTooltipNotSeen"] = "isDywUnreadTooltipNotSeen";
    FirstTimeFlag["IsNewNCHeaderNotAcknowledged"] = "isNewNcHeaderNotAcknowledged";
    FirstTimeFlag["IsNewNCPageNotAcknowledged"] = "isNewNcPageNotAcknowledged";
    FirstTimeFlag["IsSubscriptionsTabNotViewed"] = "isSubscriptionsTabNotViewed";
    FirstTimeFlag["IsBrowseSubscriptionsPromotionNotSeen"] = "isBrowseSubscriptionsPromotionNotSeen";
    FirstTimeFlag["IsMsLockedArtNotSeen"] = "isMsLockedArtNotSeen";
    FirstTimeFlag["IsMsSubscriptionNotPurchased"] = "isMsSubscriptionNotPurchased";
    FirstTimeFlag["IsDyw3RemoveNotSeen"] = "isDyw3RemoveNotSeen";
    FirstTimeFlag["IsDyw3WatchBannerNotSeen"] = "isDyw3WatchBannerNotSeen";
    FirstTimeFlag["IsDyw3SubscriptionsFilterNotSeen"] = "isDyw3SubscriptionsFilterNotSeen";
    FirstTimeFlag["IsMsFirstTierNotCreated"] = "isMsFirstTierNotCreated";
})(FirstTimeFlag || (FirstTimeFlag = {}));
//# sourceMappingURL=constants.js.map